/* tresde.io — interacciones v2 (vanilla, sin librerías)
   Los clics van por DELEGACIÓN en document: funcionan siempre,
   aunque el editor de Shopify recargue secciones. */
(function () {
  'use strict';
  /* Guardián: el archivo se incluye desde cada sección; ejecutar SOLO una vez */
  if (window.__mtCargadoV2) return;
  window.__mtCargadoV2 = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ============ TEMA CLARO / OSCURO ============ */
  function aplicarTemaGuardado() {
    try {
      /* 2026-09-13 (auditoría UX): el modo CLARO es el default — es el estándar del
         ecommerce (Amazon/Temu/Shein/tiendas Shopify) y reduce la fricción del tráfico
         frío. El oscuro "galería" sigue a un clic y se respeta si el usuario lo eligió. */
      var pref = localStorage.getItem('mt-tema');
      var esEstudio = location.pathname.indexOf('/pages/estudio') === 0;
      /* claro por defecto en la tienda; OSCURO por defecto en el Estudio (2026-09-26) */
      if (pref === 'oscuro' || (!pref && esEstudio)) {
        document.documentElement.removeAttribute('data-mt-tema');
      } else {
        document.documentElement.setAttribute('data-mt-tema', 'claro');
      }
    } catch (e) {}
  }
  function alternarTema() {
    var html = document.documentElement;
    var claro = html.getAttribute('data-mt-tema') === 'claro';
    if (claro) {
      html.removeAttribute('data-mt-tema');
    } else {
      html.setAttribute('data-mt-tema', 'claro');
    }
    try { localStorage.setItem('mt-tema', claro ? 'oscuro' : 'claro'); } catch (e) {}
    repintarTrasCambioDeTema();
  }

  /* Al cambiar el atributo del <html> por JS, el navegador no vuelve a resolver
     `color: var(--mt-…)` en los elementos ya pintados: se quedaban con el color
     del modo anterior y, sobre el fondo nuevo, resultaban ilegibles hasta
     recargar (lo sufrían los enlaces del pie y los botones del hero). Un
     reflow del body lo obliga a recalcular toda la página; dura un fotograma. */
  function repintarTrasCambioDeTema() {
    var b = document.body;
    if (!b) return;
    var previo = b.style.display;
    b.style.display = 'none';
    void b.offsetHeight; /* fuerza el reflow */
    b.style.display = previo;
  }

  aplicarTemaGuardado();

  /* ============ CLICS DELEGADOS ============ */
  document.addEventListener('click', function (e) {
    var t = e.target;

    /* Botón de tema */
    var temaBtn = t.closest('.mt-tema-btn');
    if (temaBtn) { e.preventDefault(); alternarTema(); return; }

    /* FAQ / desplegables */
    var pregunta = t.closest('.mt-faq__pregunta');
    if (pregunta) {
      e.preventDefault();
      var item = pregunta.closest('.mt-faq__item');
      var resp = item.querySelector('.mt-faq__respuesta');
      var abierto = item.classList.contains('mt-abierto');
      item.classList.toggle('mt-abierto', !abierto);
      pregunta.setAttribute('aria-expanded', String(!abierto));
      if (resp) resp.style.maxHeight = abierto ? '0px' : resp.scrollHeight + 'px';
      return;
    }

    /* Flechas de carrusel (buscan SU carrusel dentro de la misma sección) */
    var flecha = t.closest('[data-mt-prev], [data-mt-next]');
    if (flecha) {
      e.preventDefault();
      var seccion = flecha.closest('.shopify-section') || flecha.closest('.mt-section') || document;
      var pista = seccion.querySelector('.mt-carrusel');
      if (pista) {
        var tarjeta = pista.querySelector('.mt-carrusel > *');
        var paso = tarjeta ? tarjeta.getBoundingClientRect().width + 24 : 320;
        pista.scrollBy({ left: flecha.hasAttribute('data-mt-prev') ? -paso : paso, behavior: 'smooth' });
      }
      return;
    }

    /* Miniaturas de la galería de producto */
    var mini = t.closest('.mt-producto__mini');
    if (mini) {
      e.preventDefault();
      var galeria = mini.closest('[data-mt-galeria]');
      var principal = galeria && galeria.querySelector('[data-mt-imagen-principal]');
      var url = mini.getAttribute('data-mt-url');
      if (principal && url) {
        principal.style.opacity = '0';
        setTimeout(function () {
          principal.src = url;
          principal.onload = function () { principal.style.opacity = '1'; };
        }, 160);
        galeria.querySelectorAll('.mt-producto__mini').forEach(function (m) { m.classList.remove('mt-activa'); });
        mini.classList.add('mt-activa');
      }
      return;
    }

    /* Píldoras de variantes */
    var pildora = t.closest('.mt-pildora');
    if (pildora) {
      e.preventDefault();
      var grupo = pildora.closest('.mt-opcion');
      if (grupo) {
        grupo.querySelectorAll('.mt-pildora').forEach(function (p) { p.classList.remove('mt-activa'); });
        pildora.classList.add('mt-activa');
        var visor = grupo.querySelector('[data-mt-valor-activo]');
        if (visor) visor.textContent = pildora.getAttribute('data-mt-valor');
        actualizarVariante(pildora.closest('[data-mt-producto]'));
      }
      return;
    }

    /* Cantidad +/- */
    var cambioCant = t.closest('[data-mt-menos], [data-mt-mas]');
    if (cambioCant) {
      e.preventDefault();
      var caja = cambioCant.closest('.mt-cantidad');
      var input = caja && caja.querySelector('input');
      if (input) {
        var v = parseInt(input.value || '1', 10);
        input.value = cambioCant.hasAttribute('data-mt-menos') ? Math.max(1, v - 1) : v + 1;
      }
      return;
    }

    /* Biblioteca de materiales */
    var material = t.closest('.mt-material');
    if (material) {
      e.preventDefault();
      var mSeccion = material.closest('.mt-section');
      if (mSeccion) {
        var esferaGrande = mSeccion.querySelector('[data-mt-esfera-grande]');
        var nombreEl = mSeccion.querySelector('[data-mt-material-nombre]');
        if (esferaGrande) esferaGrande.style.setProperty('--c', material.getAttribute('data-mt-color'));
        var figura = mSeccion.querySelector('[data-mt-figura-grande]');
        if (figura && figura.getAttribute('data-mt-base')) {
          var slugM = String(material.getAttribute('data-mt-nombre') || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-');
          figura.hidden = false; if (esferaGrande) esferaGrande.hidden = true;
          figura.src = figura.getAttribute('data-mt-base') + 'mt-acabado-' + slugM + '.webp';
        }
        if (nombreEl) nombreEl.textContent = material.getAttribute('data-mt-nombre');
        mSeccion.querySelectorAll('.mt-material').forEach(function (m) { m.classList.remove('mt-activa'); });
        material.classList.add('mt-activa');
      }
      return;
    }
  });

  /* ============ VARIANTES DE PRODUCTO ============ */
  function actualizarVariante(seccion) {
    if (!seccion) return;
    var datos = seccion.querySelector('[data-mt-variantes]');
    if (!datos) return;
    var variantes;
    try { variantes = JSON.parse(datos.textContent); } catch (err) { return; }

    var sel = [];
    seccion.querySelectorAll('.mt-opcion').forEach(function (grupo) {
      var activa = grupo.querySelector('.mt-pildora.mt-activa');
      sel.push(activa ? activa.getAttribute('data-mt-valor') : null);
    });
    var variante = variantes.find(function (v) {
      return v.options.every(function (op, i) { return op === sel[i]; });
    });
    if (!variante) return;

    var moneda = seccion.getAttribute('data-mt-moneda') || '$';
    function fmt(centavos) {
      var partes = (centavos / 100).toFixed(2).split('.');
      partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return moneda + partes.join('.').replace(/\.00$/, '');
    }

    var inputId = seccion.querySelector('input[name="id"]');
    var precioEl = seccion.querySelector('[data-mt-precio]');
    var compararEl = seccion.querySelector('[data-mt-comparar]');
    var botonEl = seccion.querySelector('[data-mt-boton]');
    var agotadoEl = seccion.querySelector('[data-mt-agotado]');

    if (inputId) inputId.value = variante.id;
    if (precioEl) precioEl.textContent = fmt(variante.price);
    if (compararEl) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        compararEl.textContent = fmt(variante.compare_at_price);
        compararEl.hidden = false;
      } else {
        compararEl.hidden = true;
      }
    }
    if (botonEl) {
      botonEl.toggleAttribute('disabled', !variante.available);
      botonEl.textContent = variante.available
        ? botonEl.getAttribute('data-mt-texto')
        : botonEl.getAttribute('data-mt-texto-agotado');
    }
    if (agotadoEl) agotadoEl.hidden = variante.available;
    if (variante.featured_image && variante.featured_image.src) {
      var principal = seccion.querySelector('[data-mt-imagen-principal]');
      if (principal) principal.src = variante.featured_image.src;
    }
  }

  /* ============ REVEALS + CIFRAS (observers) ============ */
  var revealObserver = null;
  function initReveals() {
    var elementos = document.querySelectorAll('.mt-reveal:not(.mt-visible):not([data-mt-observado])');
    if (!elementos.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      elementos.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (entrada) {
          if (entrada.isIntersecting) {
            entrada.target.classList.add('mt-visible');
            revealObserver.unobserve(entrada.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
    }
    elementos.forEach(function (el) {
      el.setAttribute('data-mt-observado', '1');
      revealObserver.observe(el);
    });
  }

  function initCifras() {
    var nums = document.querySelectorAll('[data-mt-countup]:not([data-mt-contado])');
    if (!nums.length || !('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (!entrada.isIntersecting) return;
        obs.unobserve(entrada.target);
        var el = entrada.target;
        var fin = parseFloat(el.getAttribute('data-mt-countup')) || 0;
        var sufijo = el.getAttribute('data-mt-sufijo') || '';
        if (reduceMotion) { el.textContent = fin + sufijo; return; }
        var t0 = null;
        function paso(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / 1400, 1);
          el.textContent = Math.round(fin * (1 - Math.pow(1 - p, 3))) + sufijo;
          if (p < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      });
    }, { threshold: 0.6 });
    nums.forEach(function (el) {
      el.setAttribute('data-mt-contado', '1');
      obs.observe(el);
    });
  }

  /* ============ ARRASTRE DE CARRUSELES ============ */
  function initArrastre() {
    document.querySelectorAll('.mt-carrusel:not([data-mt-arrastre])').forEach(function (pista) {
      pista.setAttribute('data-mt-arrastre', '1');
      var bajado = false, inicioX = 0, inicioScroll = 0, movido = false;
      pista.addEventListener('mousedown', function (e) {
        bajado = true; movido = false;
        inicioX = e.pageX; inicioScroll = pista.scrollLeft;
        pista.classList.add('mt-arrastrando');
      });
      window.addEventListener('mousemove', function (e) {
        if (!bajado) return;
        var delta = e.pageX - inicioX;
        if (Math.abs(delta) > 6) movido = true;
        pista.scrollLeft = inicioScroll - delta;
      });
      window.addEventListener('mouseup', function () {
        bajado = false;
        pista.classList.remove('mt-arrastrando');
      });
      pista.addEventListener('click', function (e) {
        if (movido) { e.preventDefault(); e.stopPropagation(); movido = false; }
      }, true);
    });
  }

  /* ============ PARALLAX TIPO APPLE (solo transform/opacity) ============ */
  function initParallax() {
    if (reduceMotion) return;
    var capas = document.querySelectorAll('[data-mt-parallax]');
    var heroFade = document.querySelector('[data-mt-hero-fade]');
    var cue = document.querySelector('.mt-hero__cue');
    if (!capas.length && !heroFade) return;
    var ticking = false;
    function marco() {
      ticking = false;
      var y = window.scrollY;
      capas.forEach(function (el) {
        var vel = parseFloat(el.getAttribute('data-mt-parallax')) || 0.08;
        var rect = el.getBoundingClientRect();
        if (rect.bottom < -200 || rect.top > window.innerHeight + 200) return;
        el.style.transform = 'translateY(' + (-(y * vel)).toFixed(1) + 'px)';
      });
      if (heroFade && window.innerWidth >= 990) {
        var alto = window.innerHeight * 0.8;
        var p = Math.min(y / alto, 1);
        heroFade.style.opacity = String(1 - p * 0.9);
        heroFade.style.transform = 'translateY(' + (y * 0.12).toFixed(1) + 'px)';
      }
      if (cue) cue.style.opacity = y > 60 ? '0' : '1';
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(marco); }
    }, { passive: true });
    marco();
  }

  /* ============ INCLINACIÓN 3D AL RATÓN ============ */
  function initTilt() {
    if (reduceMotion || 'ontouchstart' in window) return;
    document.querySelectorAll('[data-mt-tilt]:not([data-mt-tilt-listo])').forEach(function (el) {
      el.setAttribute('data-mt-tilt-listo', '1');
      var max = 7;
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(900px) rotateY(' + (px * max).toFixed(2) + 'deg) rotateX(' + (-py * max).toFixed(2) + 'deg) scale(1.015)';
      });
      el.addEventListener('mouseleave', function () {
        el.style.transform = 'perspective(900px) rotateY(0deg) rotateX(0deg) scale(1)';
      });
    });
  }

  /* ============ ARRANQUE ============ */
  function initTodo() {
    initReveals();
    initCifras();
    initArrastre();
    initTilt();
    /* Definidas por el bloque v3 más abajo; con defer este bloque puede ejecutarse
       antes de que existan (readyState 'interactive') — el propio v3 las llama al definirse */
    if (typeof window.initMarqueeTestimonios === 'function') window.initMarqueeTestimonios();
    if (typeof window.initScrollJack === 'function') window.initScrollJack();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initTodo();
      initParallax();
      actualizarVariante(document.querySelector('[data-mt-producto]'));
    });
  } else {
    initTodo();
    initParallax();
    actualizarVariante(document.querySelector('[data-mt-producto]'));
  }

  document.addEventListener('shopify:section:load', initTodo);
})();

/* ============ v3 — Ronda de cambios 1 ============ */
(function () {
  'use strict';
  if (window.__mtCargadoV3) return;
  window.__mtCargadoV3 = true;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Marquesina automática de testimonios: duplica el contenido para bucle continuo */
  window.initMarqueeTestimonios = function () {
    document.querySelectorAll('.mt-testimonios__marquee:not([data-mt-listo])').forEach(function (marquee) {
      marquee.setAttribute('data-mt-listo', '1');
      var pista = marquee.querySelector('.mt-testimonios__pista');
      if (!pista || reduceMotion) return;
      var originales = Array.prototype.slice.call(pista.children);
      if (!originales.length) return;
      /* Duplica hasta cubrir 2× el ancho visible para un bucle sin salto */
      var ancho = window.innerWidth || document.documentElement.clientWidth || 1400;
      var copias = 0;
      do {
        originales.forEach(function (el) { pista.appendChild(el.cloneNode(true)); });
        copias++;
      } while (pista.scrollWidth < ancho * 2.2 && copias < 6);
    });
  };

  /* Scroll vertical → desplazamiento horizontal del carrusel (escritorio) */
  var jacks = [];
  window.initScrollJack = function () {
    if (reduceMotion) return;
    document.querySelectorAll('[data-mt-stickyh]:not([data-mt-listo])').forEach(function (seccion) {
      seccion.setAttribute('data-mt-listo', '1');
      jacks.push(seccion);
    });
    if (!jacks.length || window.__mtJackActivo) return;
    window.__mtJackActivo = true;

    function medir() {
      jacks.forEach(function (seccion) {
        var pista = seccion.querySelector('.mt-carrusel');
        var viewport = seccion.querySelector('.mt-stickyh__viewport');
        if (!pista || !viewport) return;
        var anchoVentana = window.innerWidth || document.documentElement.clientWidth || 0;
        if (anchoVentana < 990) {
          seccion.classList.remove('mt-stickyh--activo');
          seccion.style.height = '';
          return;
        }
        var extra = pista.scrollWidth - pista.clientWidth;
        if (extra < 80) {
          seccion.classList.remove('mt-stickyh--activo');
          seccion.style.height = '';
          return;
        }
        seccion.classList.add('mt-stickyh--activo');
        seccion.style.height = (window.innerHeight + extra) + 'px';
      });
    }

    var ticking = false;
    function marco() {
      ticking = false;
      if ((window.innerWidth || document.documentElement.clientWidth || 0) < 990) return;
      jacks.forEach(function (seccion) {
        if (!seccion.classList.contains('mt-stickyh--activo')) return;
        var pista = seccion.querySelector('.mt-carrusel');
        var rect = seccion.getBoundingClientRect();
        var extra = pista.scrollWidth - pista.clientWidth;
        var progreso = Math.min(Math.max(-rect.top / (rect.height - window.innerHeight), 0), 1);
        pista.scrollLeft = progreso * extra;
      });
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(marco); }
    }, { passive: true });
    window.addEventListener('resize', function () { medir(); marco(); });
    medir();
    marco();
    /* Re-mide cuando cargan las imágenes de las tarjetas */
    window.addEventListener('load', function () { medir(); marco(); });
    setTimeout(function () { medir(); marco(); }, 1200);
  };

  /* Visor (lightbox) de la galería */
  function abrirModal(item) {
    var modal = document.querySelector('.mt-modal');
    if (!modal) return;
    var img = item.querySelector('img');
    var mImg = modal.querySelector('.mt-modal__imagen img');
    var mTitulo = modal.querySelector('.mt-modal__titulo');
    var mTexto = modal.querySelector('.mt-modal__texto');
    if (mImg && img) { mImg.src = img.currentSrc || img.src; mImg.alt = img.alt || ''; }
    if (mTitulo) mTitulo.textContent = item.getAttribute('data-mt-titulo') || '';
    if (mTexto) mTexto.textContent = item.getAttribute('data-mt-texto') || '';
    modal.classList.add('mt-abierta');
    document.documentElement.style.overflow = 'hidden';
  }
  function cerrarModal() {
    var modal = document.querySelector('.mt-modal.mt-abierta');
    if (!modal) return;
    modal.classList.remove('mt-abierta');
    document.documentElement.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var item = e.target.closest('.mt-galeria__item[data-mt-lightbox]');
    if (item) { e.preventDefault(); abrirModal(item); return; }
    if (e.target.closest('.mt-modal__cerrar')) { cerrarModal(); return; }
    var modalAbierta = document.querySelector('.mt-modal.mt-abierta');
    if (modalAbierta && e.target === modalAbierta) { cerrarModal(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cerrarModal();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.initMarqueeTestimonios();
      window.initScrollJack();
    });
  } else {
    window.initMarqueeTestimonios();
    window.initScrollJack();
  }
})();

/* ============ v4 — Hero 3D con scroll + partículas doradas ============ */
(function () {
  'use strict';
  if (window.__mtCargadoV4) return;
  window.__mtCargadoV4 = true;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Giro de la figura guiado por el scroll ---------- */
  function initEscena() {
    var escena = document.querySelector('[data-mt-escena]');
    if (!escena || escena.hasAttribute('data-mt-escena-lista') || reduceMotion) return;
    escena.setAttribute('data-mt-escena-lista', '1');

    var img = escena.querySelector('[data-mt-giro]');
    var texto = escena.querySelector('[data-mt-escena-texto]');
    var figura = escena.querySelector('[data-mt-escena-figura]');
    var cue = escena.querySelector('.mt-hero__cue');
    if (!img) return;

    var total = parseInt(escena.getAttribute('data-mt-frames'), 10) || 72;
    var vueltas = parseInt(escena.getAttribute('data-mt-vueltas'), 10) || 1;
    var base = escena.getAttribute('data-mt-frame-base') || img.src;
    /* En móvil: juego de fotogramas reducido (380px) + 1 de cada 2 */
    var esMovil = (window.innerWidth || document.documentElement.clientWidth || 1000) < 750;
    var salto = esMovil ? 2 : 1;
    var baseMovil = escena.getAttribute('data-mt-frame-base-movil');
    if (esMovil && baseMovil) base = baseMovil;
    var prefijo = esMovil && baseMovil ? 'mt-giro-m-' : 'mt-giro-';
    var cw = esMovil ? 380 : 760;
    var ch = esMovil ? 475 : 950;

    /* Lienzo de dibujo directo: cambiar fotograma es un solo trazo, sin recargas */
    var lienzo = document.createElement('canvas');
    lienzo.width = cw;
    lienzo.height = ch;
    lienzo.setAttribute('aria-hidden', 'true');
    lienzo.style.display = 'none';
    img.parentNode.insertBefore(lienzo, img.nextSibling);
    var lctx = lienzo.getContext('2d');
    var lienzoActivo = false;
    function dibujar(i) {
      var im = cuadros[i];
      if (!im) return false;
      if (!lienzoActivo) {
        lienzo.style.display = 'block';
        img.style.display = 'none';
        lienzoActivo = true;
      }
      lctx.clearRect(0, 0, cw, ch);
      lctx.drawImage(im, 0, 0, cw, ch);
      return true;
    }

    /* Pre-carga progresiva de fotogramas (tras la carga de la página) */
    var cuadros = new Array(total);
    var cargados = 0;
    function urlDe(i) {
      var n = String(i);
      while (n.length < 3) n = '0' + n;
      return base.replace(prefijo + '000', prefijo + n);
    }
    function precargar() {
      var i = 0;
      function siguiente() {
        if (i >= total) return;
        var idx = i;
        i += salto;
        var im = new Image();
        im.onload = function () {
          var fin = function () {
            cuadros[idx] = im;
            cargados = Math.max(cargados, idx + 1);
            if (idx === 0) dibujar(0);
            siguiente();
          };
          if (im.decode) { im.decode().then(fin).catch(fin); } else { fin(); }
        };
        im.onerror = function () { siguiente(); };
        im.src = urlDe(idx);
      }
      /* dos hilos de carga */
      siguiente();
      siguiente();
    }
    if (document.readyState === 'complete') { precargar(); }
    else { window.addEventListener('load', precargar); }

    var frameActual = -1;
    var ticking = false;
    function marco() {
      ticking = false;
      var alto = window.innerHeight || document.documentElement.clientHeight || 800;
      var rect = escena.getBoundingClientRect();
      var recorrido = rect.height - alto;
      if (recorrido < 10) return;
      var progreso = Math.min(Math.max(-rect.top / recorrido, 0), 1);

      /* fotograma según progreso (con vueltas) */
      var f = Math.round(progreso * (total * vueltas - 1)) % total;
      if (salto > 1) f = Math.min(Math.round(f / salto) * salto, total - salto);
      if (f !== frameActual && dibujar(f)) {
        frameActual = f;
      }
      /* texto: visible el primer tercio, se desvanece después */
      var pTexto = Math.min(Math.max((progreso - 0.45) / 0.4, 0), 1);
      if (texto) {
        texto.style.opacity = String(1 - pTexto * 0.92);
        texto.style.transform = 'translateY(' + (-pTexto * 40).toFixed(1) + 'px)';
      }
      /* figura: crece sutilmente; en móvil sube al CENTRO al desvanecerse el texto */
      if (figura) {
        var esc = 1 + progreso * 0.1;
        var subida = 0;
        var anchoV = window.innerWidth || document.documentElement.clientWidth || 1200;
        if (anchoV < 990 && texto) {
          subida = pTexto * (texto.offsetHeight * 0.62 + 20);
        }
        figura.style.transform = 'translateY(-' + subida.toFixed(1) + 'px) scale(' + esc.toFixed(3) + ')';
      }
      if (cue) cue.style.opacity = progreso > 0.04 ? '0' : '1';
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(marco); }
    }, { passive: true });
    window.addEventListener('resize', marco);
    /* Red de seguridad: si el navegador pausa los rAF, seguimos al día */
    setInterval(function () { ticking = false; marco(); }, 250);
    marco();
  }

  /* ---------- Partículas doradas que forman la estrella ---------- */
  function initParticulas() {
    var canvas = document.querySelector('[data-mt-particulas]:not([data-mt-listo])');
    if (!canvas || reduceMotion) return;
    canvas.setAttribute('data-mt-listo', '1');
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var ancho = 0, alto = 0;
    var particulas = [];
    var raton = { x: -9999, y: -9999 };
    var colores = ['#d4af37', '#f6e27a', '#b8912e', '#8e6b1e'];
    var objetivos = [];
    var visible = true;

    function medir() {
      var r = canvas.getBoundingClientRect();
      ancho = Math.max(r.width, 300);
      alto = Math.max(r.height, 300);
      canvas.width = ancho * dpr;
      canvas.height = alto * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    /* Muestrea la silueta de la estrella (isotipo) para los puntos objetivo */
    function muestrear(im) {
      var oc = document.createElement('canvas');
      var t = 110;
      oc.width = t; oc.height = t;
      var octx = oc.getContext('2d');
      octx.drawImage(im, 0, 0, t, t);
      var datos;
      try { datos = octx.getImageData(0, 0, t, t).data; } catch (e) { return; }
      objetivos = [];
      for (var y = 0; y < t; y += 2) {
        for (var x = 0; x < t; x += 2) {
          if (datos[(y * t + x) * 4 + 3] > 120 && Math.random() < 0.5) {
            objetivos.push({ x: x / t, y: y / t });
          }
        }
      }
      crear();
    }

    function crear() {
      var n = Math.min(objetivos.length, (window.innerWidth || 1200) < 750 ? 160 : 320);
      particulas = [];
      /* estrella centrada tras la figura, lado derecho en escritorio */
      var esDesktop = (window.innerWidth || document.documentElement.clientWidth) >= 990;
      var cx = esDesktop ? ancho * 0.72 : ancho * 0.5;
      var cy = esDesktop ? alto * 0.46 : alto * 0.34;
      var tam = Math.min(ancho, alto) * (esDesktop ? 0.52 : 0.62);
      for (var i = 0; i < n; i++) {
        var o = objetivos[Math.floor(Math.random() * objetivos.length)];
        particulas.push({
          x: Math.random() * ancho,
          y: Math.random() * alto,
          hx: cx + (o.x - 0.5) * tam,
          hy: cy + (o.y - 0.5) * tam,
          vx: 0, vy: 0,
          r: 0.8 + Math.random() * 1.6,
          c: colores[Math.floor(Math.random() * colores.length)],
          fase: Math.random() * Math.PI * 2
        });
      }
    }

    function paso(t) {
      if (!visible) { requestAnimationFrame(paso); return; }
      ctx.clearRect(0, 0, ancho, alto);
      for (var i = 0; i < particulas.length; i++) {
        var p = particulas[i];
        /* atracción suave al punto de la estrella + deriva */
        var dx = p.hx - p.x + Math.sin(t / 1400 + p.fase) * 6;
        var dy = p.hy - p.y + Math.cos(t / 1600 + p.fase) * 6;
        p.vx += dx * 0.012;
        p.vy += dy * 0.012;
        /* repulsión del ratón */
        var mx = p.x - raton.x, my = p.y - raton.y;
        var d2 = mx * mx + my * my;
        if (d2 < 16900) {
          var d = Math.sqrt(d2) || 1;
          var f = (130 - d) / 130;
          p.vx += (mx / d) * f * 2.6;
          p.vy += (my / d) * f * 2.6;
        }
        p.vx *= 0.88;
        p.vy *= 0.88;
        p.x += p.vx;
        p.y += p.vy;
        ctx.globalAlpha = 0.75;
        ctx.fillStyle = p.c;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, 6.2832);
        ctx.fill();
      }
      ctx.globalAlpha = 1;
      requestAnimationFrame(paso);
    }

    var contenedor = canvas.closest('[data-mt-escena]') || canvas.parentElement;
    contenedor.addEventListener('mousemove', function (e) {
      var r = canvas.getBoundingClientRect();
      raton.x = e.clientX - r.left;
      raton.y = e.clientY - r.top;
    });
    contenedor.addEventListener('mouseleave', function () { raton.x = -9999; raton.y = -9999; });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }).observe(canvas);
    }
    window.addEventListener('resize', function () { medir(); crear(); });

    medir();
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () { muestrear(im); };
    im.src = canvas.getAttribute('data-mt-forma');
    requestAnimationFrame(paso);
  }

  function arrancar() { initEscena(); initParticulas(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
  document.addEventListener('shopify:section:load', arrancar);
})();

/* ============ v5 — Destello dorado interactivo ============ */
(function () {
  'use strict';
  if (window.__mtCargadoV5) return;
  window.__mtCargadoV5 = true;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initDestello() {
    var escena = document.querySelector('[data-mt-escena]');
    var destello = document.querySelector('[data-mt-destello]:not([data-mt-listo])');
    if (!escena || !destello || reduceMotion) return;
    destello.setAttribute('data-mt-listo', '1');
    var objetivoX = 0, objetivoY = 0, actualX = 0, actualY = 0, animando = false;

    function animar() {
      actualX += (objetivoX - actualX) * 0.06;
      actualY += (objetivoY - actualY) * 0.06;
      destello.style.transform = 'translate(calc(-50% + ' + actualX.toFixed(1) + 'px), calc(-50% + ' + actualY.toFixed(1) + 'px))';
      if (Math.abs(objetivoX - actualX) > 0.3 || Math.abs(objetivoY - actualY) > 0.3) {
        requestAnimationFrame(animar);
      } else {
        animando = false;
      }
    }
    escena.addEventListener('mousemove', function (e) {
      var r = escena.getBoundingClientRect();
      var nx = (e.clientX - r.left) / Math.max(r.width, 1) - 0.5;
      var ny = (e.clientY - r.top) / Math.max(r.height, 1) - 0.5;
      objetivoX = nx * 46;
      objetivoY = ny * 34;
      if (!animando) { animando = true; requestAnimationFrame(animar); }
    });
    escena.addEventListener('mouseleave', function () {
      objetivoX = 0;
      objetivoY = 0;
      if (!animando) { animando = true; requestAnimationFrame(animar); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDestello);
  } else {
    initDestello();
  }
  document.addEventListener('shopify:section:load', initDestello);
})();

/* ============ v7 — Personalizador (estado + resumen + precio) ============ */
(function () {
  'use strict';
  if (window.__mtCargadoV7) return;
  window.__mtCargadoV7 = true;

  function money(n) {
    return '$' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function filtrarPoses(zona) {
    var grupoTipo = zona.querySelector('[data-mt-grupo="Tipo de pieza"] .mt-pildora.mt-activa');
    var tipo = grupoTipo ? grupoTipo.getAttribute('data-mt-eleccion') : '';
    var set = 'gesto';
    if (tipo === 'Cuerpo completo') set = 'cuerpo';
    else if (tipo === 'Pareja') set = 'pareja';
    var titulo = zona.querySelector('[data-mt-pose-titulo]');
    if (titulo) titulo.textContent = set === 'gesto' ? 'Elige el gesto' : (set === 'pareja' ? 'Elige la pose de pareja' : 'Elige la pose');
    var pills = zona.querySelectorAll('[data-mt-pose-set]');
    if (!pills.length) return;
    var activaVisible = false;
    pills.forEach(function (p) {
      var visible = p.getAttribute('data-mt-pose-set') === set;
      p.style.display = visible ? '' : 'none';
      if (!visible) p.classList.remove('mt-activa');
      else if (p.classList.contains('mt-activa')) activaVisible = true;
    });
    if (!activaVisible) {
      var primera = zona.querySelector('[data-mt-pose-set="' + set + '"]');
      if (primera) primera.classList.add('mt-activa');
    }
  }

  function actualizarResumen(zona) {
    var config = [];
    var total = 0;
    var valores = {};
    zona.querySelectorAll('[data-mt-grupo]').forEach(function (grupo) {
      var nombre = grupo.getAttribute('data-mt-grupo');
      var activa = grupo.querySelector('.mt-pildora.mt-activa');
      var valor = activa ? activa.getAttribute('data-mt-eleccion') : '—';
      valores[nombre] = valor;
      config.push(nombre + ': ' + valor);
      var res = zona.querySelector('[data-mt-res="' + nombre + '"]');
      if (res) res.textContent = valor;
      if (nombre === 'Tamaño' && activa) {
        total += parseInt(activa.getAttribute('data-mt-precio'), 10) || 0;
      }
    });
    zona.querySelectorAll('[data-mt-nota-si]').forEach(function (n) {
      var cond = (n.getAttribute('data-mt-nota-si') || '').split(':');
      var ver = valores[cond[0]] === cond[1];
      n.hidden = !ver;
      n.style.display = ver ? '' : 'none';
    });
    var extras = [];
    zona.querySelectorAll('[data-mt-extra].mt-activa').forEach(function (ex) {
      var nombreEx = ex.getAttribute('data-mt-extra');
      var precioEx = parseInt(ex.getAttribute('data-mt-extra-precio'), 10) || 0;
      total += precioEx;
      extras.push(nombreEx + ' (+$' + precioEx + ')');
    });
    var placa = zona.querySelector('[data-mt-placa-texto]');
    if (placa) {
      placa.hidden = extras.length === 0;
      if (extras.length && placa.value.trim()) {
        extras[extras.length - 1] += ' — Texto: "' + placa.value.trim() + '"';
      }
    }
    var resEx = zona.querySelector('[data-mt-res="Extras"]');
    if (resEx) resEx.textContent = extras.length ? extras.join(', ').replace(/ — Texto: .*$/, '') : '—';
    config.push('Extras: ' + (extras.length ? extras.join(', ') : 'Ninguno'));
    var visor = zona.querySelector('[data-mt-precio-estimado]');
    if (visor && total > 0) visor.textContent = money(total) + ' MXN';
    var campo = zona.querySelector('[data-mt-config]');
    if (campo) campo.value = config.join(' | ');
  }

  document.addEventListener('click', function (e) {
    var extra = e.target.closest('[data-mt-personaliza] [data-mt-extra]');
    if (extra) {
      extra.classList.toggle('mt-activa');
      actualizarResumen(extra.closest('[data-mt-personaliza]'));
      return;
    }
    var pildora = e.target.closest('[data-mt-personaliza] [data-mt-grupo] .mt-pildora');
    if (!pildora) return;
    var grupo = pildora.closest('[data-mt-grupo]');
    grupo.querySelectorAll('.mt-pildora').forEach(function (p) { p.classList.remove('mt-activa'); });
    pildora.classList.add('mt-activa');
    if (grupo.getAttribute('data-mt-grupo') === 'Tipo de pieza') filtrarPoses(pildora.closest('[data-mt-personaliza]'));
    actualizarResumen(pildora.closest('[data-mt-personaliza]'));
  });

  document.addEventListener('input', function (e) {
    var placa = e.target.closest('[data-mt-personaliza] [data-mt-placa-texto]');
    if (placa) actualizarResumen(placa.closest('[data-mt-personaliza]'));
  });

  /* Peek al pasar el cursor (estilo Estudio) */
  var persoPeek = null, persoPeekTimer = null;
  function peekEl() {
    if (!persoPeek) {
      persoPeek = document.createElement('div');
      persoPeek.className = 'mt-perso-peek';
      persoPeek.innerHTML = '<strong></strong><p></p>';
      document.body.appendChild(persoPeek);
    }
    return persoPeek;
  }
  document.addEventListener('mouseover', function (e) {
    var anchoPeek = window.innerWidth || document.documentElement.clientWidth || 1280;
    if (anchoPeek < 861) return;
    var pill = e.target.closest('[data-mt-personaliza] .mt-pildora[data-mt-desc]');
    if (!pill) return;
    clearTimeout(persoPeekTimer);
    persoPeekTimer = setTimeout(function () {
      var el = peekEl();
      el.querySelector('strong').textContent = pill.getAttribute('data-mt-eleccion');
      el.querySelector('p').textContent = pill.getAttribute('data-mt-desc');
      el.classList.add('mt-visible');
      var r = pill.getBoundingClientRect();
      el.style.left = Math.max(12, Math.min((window.innerWidth || document.documentElement.clientWidth || 1280) - 290, r.left + r.width / 2 - 135)) + 'px';
      var alto = el.offsetHeight || 80;
      var top = r.top - alto - 10;
      if (top < 12) top = r.bottom + 10;
      el.style.top = top + 'px';
    }, 140);
  });
  document.addEventListener('mouseout', function (e) {
    var pill = e.target.closest && e.target.closest('[data-mt-personaliza] .mt-pildora[data-mt-desc]');
    if (!pill) return;
    clearTimeout(persoPeekTimer);
    if (persoPeek) persoPeek.classList.remove('mt-visible');
  });
  document.addEventListener('scroll', function () {
    if (persoPeek) persoPeek.classList.remove('mt-visible');
  }, true);

  /* Envío al carrito: variante por talla, propiedades y extra de placa */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-mt-carrito]');
    if (!form) return;
    var zona = form.closest('[data-mt-personaliza]') || document.querySelector('[data-mt-personaliza]');
    if (!zona) return;
    var mapa = {};
    try { mapa = JSON.parse(form.getAttribute('data-mt-variantes') || '{}'); } catch (err) {}
    var talla = zona.querySelector('[data-mt-grupo="Tamaño"] .mt-pildora.mt-activa');
    var vid = talla ? mapa[talla.getAttribute('data-mt-eleccion')] : null;
    if (vid) form.querySelector('[data-mt-var-id]').value = vid;
    ['Ocasión', 'Tipo de pieza', 'Estilo', 'Color', 'Pose'].forEach(function (nombre) {
      var g = zona.querySelector('[data-mt-grupo="' + nombre + '"] .mt-pildora.mt-activa');
      var inp = form.querySelector('[data-mt-prop="' + nombre + '"]');
      if (inp) inp.value = g ? g.getAttribute('data-mt-eleccion') : '';
    });
    var extra = zona.querySelector('[data-mt-extra].mt-activa');
    var placaTxt = zona.querySelector('[data-mt-placa-texto]');
    var pe = form.querySelector('[data-mt-prop-extras]');
    if (pe) pe.value = extra ? extra.getAttribute('data-mt-extra') + ' (+$' + (extra.getAttribute('data-mt-extra-precio') || '') + ')' : 'Ninguno';
    var pp = form.querySelector('[data-mt-prop-placa]');
    if (pp) pp.value = (extra && placaTxt) ? placaTxt.value.trim() : '';
    if (extra && form.getAttribute('data-mt-placa-id') && !form.hasAttribute('data-mt-placa-lista')) {
      e.preventDefault();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(form.getAttribute('data-mt-placa-id'), 10), quantity: 1, properties: { 'Texto de la placa': pp ? pp.value : '' } }] })
      }).catch(function () {}).finally(function () {
        form.setAttribute('data-mt-placa-lista', '1');
        form.submit();
      });
    }
  }, true);

  function initPersonaliza() {
    var zona = document.querySelector('[data-mt-personaliza]');
    if (zona) { filtrarPoses(zona); actualizarResumen(zona); }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPersonaliza);
  } else {
    initPersonaliza();
  }
  document.addEventListener('shopify:section:load', initPersonaliza);
})();

/* ============ v8 — Demo interactiva: generación simulada + visor 3D ============ */
(function () {
  'use strict';
  if (window.__mtCargadoV8) return;
  window.__mtCargadoV8 = true;

  var MENSAJES = [
    'Leyendo tu configuración…',
    'Esculpiendo los rasgos…',
    'Aplicando el estilo elegido…',
    'Puliendo el acabado…',
    'Tu propuesta está lista ✦'
  ];

  function etapa(demo, n) {
    demo.querySelectorAll('[data-mt-demo-etapa]').forEach(function (e) {
      e.hidden = e.getAttribute('data-mt-demo-etapa') !== String(n);
    });
  }

  function cargarVisor(demo) {
    var visor = demo.querySelector('[data-mt-demo-visor]');
    if (!visor || visor.hasAttribute('data-mt-cargado')) return;
    visor.setAttribute('data-mt-cargado', '1');
    var glb = demo.getAttribute('data-mt-glb');
    function crear() {
      var mv = document.createElement('model-viewer');
      mv.setAttribute('src', glb);
      mv.setAttribute('camera-controls', '');
      mv.setAttribute('auto-rotate', '');
      mv.setAttribute('rotation-per-second', '25deg');
      mv.setAttribute('shadow-intensity', '1');
      mv.setAttribute('exposure', '1.1');
      mv.setAttribute('camera-orbit', '0deg 82deg 105%');
      mv.setAttribute('alt', 'Modelo 3D interactivo de demostración');
      visor.appendChild(mv);
    }
    if (window.customElements && window.customElements.get('model-viewer')) {
      crear();
    } else {
      var sc = document.createElement('script');
      sc.type = 'module';
      sc.src = 'https://cdn.jsdelivr.net/npm/@google/model-viewer@3.5.0/dist/model-viewer.min.js';
      sc.onload = crear;
      document.head.appendChild(sc);
    }
  }

  document.addEventListener('click', function (e) {
    var demo = e.target.closest('[data-mt-demo]');
    if (!demo) return;

    if (e.target.closest('[data-mt-demo-generar]')) {
      etapa(demo, 2);
      var barra = demo.querySelector('[data-mt-demo-barra]');
      var estado = demo.querySelector('[data-mt-demo-estado]');
      var p = 0;
      var tick = setInterval(function () {
        p += 4 + Math.random() * 7;
        if (p >= 100) {
          p = 100;
          clearInterval(tick);
          setTimeout(function () { etapa(demo, 3); }, 350);
        }
        if (barra) barra.style.width = p + '%';
        if (estado) estado.textContent = MENSAJES[Math.min(Math.floor(p / 22), MENSAJES.length - 1)];
      }, 160);
      /* pre-carga el visor mientras "genera" */
      cargarVisor(demo);
      return;
    }

    if (e.target.closest('[data-mt-demo-aprobar]')) {
      etapa(demo, 4);
      return;
    }

    var ir = e.target.closest('[data-mt-demo-ir-form]');
    if (ir) {
      e.preventDefault();
      var form = document.querySelector('.mt-perso__resumen');
      if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
  });
})();

/* ═══ Proceso interactivo: la imagen cambia con el paso (hover escritorio / scroll móvil) ═══ */
(function () {
  if (window.__mtProcesoInteractivo) return;
  window.__mtProcesoInteractivo = true;
  function init() {
    document.querySelectorAll('[data-mt-proceso-vista]').forEach(function (vista) {
      var grid = vista.closest('.mt-proceso__grid');
      if (!grid) return;
      var imgs = [].slice.call(vista.querySelectorAll('[data-mt-paso-img]'));
      var pasos = [].slice.call(grid.querySelectorAll('[data-mt-paso]'));
      if (!imgs.length || !pasos.length) return;
      function activar(n) {
        imgs.forEach(function (im) { im.classList.toggle('mt-activa', im.getAttribute('data-mt-paso-img') === String(n)); });
        pasos.forEach(function (p) { p.classList.toggle('mt-paso--activo', p.getAttribute('data-mt-paso') === String(n)); });
      }
      activar(pasos[0].getAttribute('data-mt-paso'));
      var fino = window.matchMedia('(hover: hover) and (min-width: 990px)');
      pasos.forEach(function (p) {
        p.addEventListener('mouseenter', function () { if (fino.matches) activar(p.getAttribute('data-mt-paso')); });
        p.addEventListener('focusin', function () { activar(p.getAttribute('data-mt-paso')); });
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entradas) {
          if (fino.matches) return; /* en escritorio manda el hover */
          entradas.forEach(function (e) {
            if (e.isIntersecting) activar(e.target.getAttribute('data-mt-paso'));
          });
        }, { rootMargin: '-42% 0px -42% 0px', threshold: 0 });
        pasos.forEach(function (p) { io.observe(p); });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


/* ── Punto dorado "tienes una figura lista" en el menú (r49) ── */
(function () {
  if (window.__mtPuntoListo) return; window.__mtPuntoListo = 1;
  function marcar(hay) {
    document.querySelectorAll('a[href*="/pages/mi-estudio"]').forEach(function (a) { a.classList.toggle('mt-tiene-lista', !!hay); });
  }
  var ls = null;
  try { ls = localStorage.getItem('mtFiguraLista'); } catch (e) {}
  if (ls === '1') { marcar(true); }
  if (ls === null) {
    /* primera visita de la sesión: preguntar al cerebro (barato, 1 vez) */
    var inv = null; try { inv = JSON.parse(localStorage.getItem('mtEstudioVisitante')); } catch (e) {}
    var q = inv ? ('?invitado=' + encodeURIComponent(inv)) : '';
    fetch('/apps/personaliza/disenos' + q).then(function (r) { return r.json(); }).then(function (d) {
      var hay = ((d && d.disenos) || []).some(function (x) { return x.estado === 'imagen_lista' && !x.pagado; });
      try { localStorage.setItem('mtFiguraLista', hay ? '1' : '0'); } catch (e) {}
      marcar(hay);
    }).catch(function () {});
  }
})();

/* ── Retorno tras pagar: "Seguir comprando" del checkout manda a la home (r51) ──
   Si el Estudio dejó un diseño esperando pago (localStorage) y el cerebro dice
   que YA está pagado, mostramos un aviso dorado que lleva de vuelta al Estudio
   (?pago=ok re-verifica y aterriza en el seguimiento del pedido). */
(function () {
  if (window.__mtVueltaPago) return; window.__mtVueltaPago = 1;
  if (location.pathname.indexOf('/pages/estudio') === 0) return; /* el Estudio ya se vigila solo */
  var g = null;
  try { g = JSON.parse(localStorage.getItem('mtEstudioEstado')); } catch (e) {}
  if (!g || !g.idDiseno || g.paso !== 2 || g.pagado) return; /* solo si quedó en el paso de pago */
  var inv = null; try { inv = JSON.parse(localStorage.getItem('mtEstudioVisitante')); } catch (e) {}
  var q = inv ? ('?invitado=' + encodeURIComponent(inv)) : '';
  fetch('/apps/personaliza/estado/' + encodeURIComponent(g.idDiseno) + q)
    .then(function (r) { return r.json(); })
    .then(function (d) {
      if (!d || !d.pagado) return;
      var aviso = document.createElement('a');
      aviso.href = '/pages/estudio?pago=ok';
      aviso.className = 'mt-aviso-pago-ok';
      aviso.innerHTML = '<b>✦ ¡Tu pago se confirmó!</b><span>Tu pieza ' + String(g.idDiseno).replace(/[<>&]/g, '') + ' ya está en producción — toca para ver el seguimiento</span><i>Ver mi pedido →</i>';
      document.body.appendChild(aviso);
    })
    .catch(function () {});
})();
